module.exports = __webpack_public_path__ + "static/media/senegal_mali_mototurismo_1.7fd29da0.jpg";